
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[slug]/[pageNo]",
      function () {
        return require("private-next-pages/topics/[slug]/[pageNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[slug]/[pageNo]"])
      });
    }
  